import React from 'react'

import {
    Button,
    Row,
    Icon
} from 'antd'

class BatchCounter extends React.Component{
    render(){
        return(
            <div>
                <style dangerouslySetInnerHTML={{__html: `
                    .ez-batch-counter {
                        transition: 0.5s ease;
                    }

                    .ez-batch-counter.hidden {
                        opacity: 0;
                    }
                `}}/>
                <div
                >
                    <Button
                    disabled={this.props.length == 0}
                    // size="small"
                    ghost
                    type="primary"
                    style={{padding: "0px 8px"}}
                    onClick={this.props.clear}>
                    Reload
                    </Button>
                    <span
                        className={`ez-batch-counter ${this.props.length == 0?'hidden':''}`}
                        style={{marginLeft: 8}}
                    >Selected {this.props.length} of {this.props.total} items</span>

                    <span
                        className={`ez-batch-counter ${this.props.length == 0?'hidden':''}`}
                        style={{marginLeft: 8}}
                    ><strong>Total Amount:</strong> {this.props.totalAmount.toFixed(2)}</span>
                </div>
            </div>
        )
    }
}

export default BatchCounter


// WEBPACK FOOTER //
// ./src/components/credit-payment/batch-counter.js